import React from "react";
import { Box, Chip, Link, useTheme } from "@mui/material";

interface ProductMetaChipsProps {
  quantity?: number | null;
  productId?: number | null;
}

const ProductMetaChips: React.FC<ProductMetaChipsProps> = ({
  quantity,
  productId,
}) => {
  const theme = useTheme();
  const chipSx = {
    height: 18,
    fontSize: "0.7rem",
    fontWeight: 700,
    borderRadius: "4px",
    "& .MuiChip-label": { px: 0.75 },
  };

  if (quantity == null && !productId) return null;

  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        gap: 0.75,
        mt: 0.5,
      }}
    >
      {quantity != null && (
        <Chip
          size="small"
          label={`Qty: ${quantity}`}
          sx={{
            ...chipSx,
            backgroundColor: theme.palette.blue.main + "18",
            color: theme.palette.blue.main,
          }}
        />
      )}
      {productId ? (
        <Link
          href={`/products/${productId}`}
          target="_blank"
          underline="none"
          style={{ padding: 0 }}
          onClick={(e) => e.stopPropagation()}
        >
          <Chip
            size="small"
            label={`#${productId}`}
            sx={{
              ...chipSx,
              backgroundColor: theme.palette.purple.main + "30",
              color: theme.palette.purple.main,
            }}
          />
        </Link>
      ) : null}
    </Box>
  );
};

export default ProductMetaChips;
